// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8e848ac","172":"d96a73a3","203":"8b9de4e7","372":"43cdb426","407":"cc0ff82b","464":"bebe6dfe","483":"59dab2c5"}[chunkId] + ".chunk.js";
};